import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form as FormikForm } from 'formik';
import OnSubmitValidationHandler from './OnSubmitValidationHandler';

const Form = ({ children, initialValues, onSubmit, onValidationFail, validateOnBlur, validateOnChange, validationSchema }) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={validationSchema}
    validateOnChange={validateOnChange}
    validateOnBlur={validateOnBlur}
  >
    {({ errors, touched, setFieldValue, isValid, dirty }) => (
      <>
        <FormikForm>{typeof children === 'function' ? children(setFieldValue, isValid, dirty) : children}</FormikForm>
        {onValidationFail && (
          <OnSubmitValidationHandler
            callback={formik => {
              onValidationFail(formik);
            }}
          />
        )}
      </>
    )}
  </Formik>
);

Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  initialValues: PropTypes.shape({}).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onValidationFail: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  validationSchema: PropTypes.shape({}),
};

Form.defaultProps = {
  onValidationFail: null,
  validateOnBlur: true,
  validateOnChange: true,
  validationSchema: null,
};

export default Form;
